import { createStyles } from 'antd-style'

import { GlobalHeader } from '@eastcoal/shared/components/GlobalHeader'

import { LayoutContainer } from '../Container'
import { LayoutNavbar } from '../Navbar'
import { LayoutTopbar } from '../Topbar'

const useStyles = createStyles(({ token }) => ({
  globalBar: {
    width: token.layoutContentWidth,
    marginInline: 'auto'
  },
  header: {
    backgroundColor: token.colorWhite,
    boxShadow: token.boxShadowTertiary
  }
}))

export const LayoutHeader = () => {
  const { styles } = useStyles()

  return (
    <>
      <GlobalHeader showMemberCenter className={styles.globalBar}>
        你好，欢迎来到东方煤炭电子交易中心！
      </GlobalHeader>
      <div className={styles.header}>
        <LayoutContainer>
          <LayoutTopbar />
          <LayoutNavbar />
        </LayoutContainer>
      </div>
    </>
  )
}
